/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Result_Action_Hubspot_TaskInputs */



/**
* | output |
* | --- |
* | "Create a HubSpot task" |
*
* @param {Agent_Result_Action_Hubspot_TaskInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_result_action_hubspot_task = /** @type {((inputs?: Agent_Result_Action_Hubspot_TaskInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Result_Action_Hubspot_TaskInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("HubSpot-Aufgabe erstellen")
	return /** @type {LocalizedString} */ ("Create a HubSpot task")
});